export default "/images/tickets.svg?d53d31288a3041bf5b390f655d97a3c8";